<template>
<div>
    <v-card class="card-profile">
        <h1 class="card-header">
            {{ $vuetify.lang.t('$vuetify.visitorForm.profile') }}
        </h1>
        <v-form
            lazy-validation
            v-model="valid"
            ref="form">
            <div class="d-flex">
                <div class="upload-container">
                    <upload-image
                        :img="imgProfile(form.profileImage)"
                        @change-profile-img="changeProfileImg"
                        :isEditing="true"
                        :showDescriptionForUploadToDmp="true"
                        :canDelete="false">
                    </upload-image>
                </div>
                <div class="profile-container">
                    <div class="row">
                        <div class="col-6">
                            <v-text-field
                                class="label-profile"
                                v-model="form.citizenId"
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.citizenIdPassportId')"
                                height="45"
                                :error-messages="errors.citizenId"
                                :rules="inputRules">
                                <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.citizenIdPassportId') }}<span class="require-star">* </span>
                                </template>
                            </v-text-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <v-text-field
                                v-model="form.firstName"
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.enterVisitorName')"
                                height="45"
                                :error-messages="errors.firstName"
                                :rules="inputRules">
                                <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.enterVisitorName') }}<span class="require-star">* </span>
                                </template>
                            </v-text-field>
                        </div>
                        <div class="col-6">
                            <v-text-field
                                v-model="form.lastName"
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.surname')"
                                height="45"
                                :error-messages="errors.lastName"
                                :rules="inputRules">
                            <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.surname') }}<span class="require-star">* </span>
                            </template>
                            </v-text-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <v-radio-group
                                v-model="form.gender"
                                row
                                class="gender"
                                :rules="inputRules">
                                <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.gender') }}<span class="require-star">* </span>
                                </template>
                                <div class="gender-radio">
                                    <v-radio
                                        :label="this.$vuetify.lang.t('$vuetify.visitorForm.male')"
                                        value="M">
                                    </v-radio>
                                    <v-radio
                                        :label="this.$vuetify.lang.t('$vuetify.visitorForm.female')"
                                        value="F">
                                    </v-radio>
                                </div>
                            </v-radio-group>
                        </div>
                        <div class="col-6">
                            <v-autocomplete
                                v-model="form.bureauId"
                                :items="bureauItems"
                                dense
                                height="40"
                                filled
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.visitAt')"
                                background-color="#ffffff"
                                :error-messages="errors.bureauId"
                                :rules="inputRules">
                                <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.visitAt') }}<span class="require-star">* </span>
                                </template>
                            </v-autocomplete>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <v-text-field
                                v-model="form.email"
                                :label="this.$vuetify.lang.t('$vuetify.visitorForm.emailAddress')"
                                height="40"
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.enterEmailAddress')">
                            </v-text-field>
                        </div>
                        <div class="col-6">
                            <v-text-field
                                v-model="form.phone"
                                :prefix="`(${nationalTelCode})`"
                                placeholder="00 000 0000"
                                autocomplete="off"
                                v-mask = "'## ### ####'">
                                <template #label>
                                    {{ $vuetify.lang.t('$vuetify.visitorForm.phoneNumber') }}
                                </template>
                            </v-text-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <div>
                                {{ $vuetify.lang.t('$vuetify.visitorForm.operator') }}<span class="require-star">* </span>
                            </div>
                            <v-autocomplete
                                class="liff-line-font-size-14"
                                v-model="form.operatorId"
                                :items="employeeItems"
                                dense
                                height="40"
                                filled
                                :hint="this.$vuetify.lang.t('$vuetify.visitorForm.operatorDetial')"
                                persistent-hint
                                :placeholder="this.$vuetify.lang.t('$vuetify.visitorForm.selectEmployeeName')"
                                background-color="#ffffff"
                                :rules="inputRules">
                            </v-autocomplete>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">
                            <upload-card-image
                                ref="uploadCardImage"
                                @change-profile-img="uploadCard">
                            </upload-card-image>
                        </div>
                    </div>
                    <div
                        v-if="form.cardImage"
                        class="row">
                        <div class="col-6">
                            <div class="card-container">
                                <img class="card-image" :src="form.cardImage">
                                <v-icon
                                    class="pointer-cursor i-remove"
                                    @click="removeImage">
                                    mdi-close-circle
                                </v-icon>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </v-form>
    </v-card>
</div>
</template>

<script>
import { mask } from 'vue-the-mask'
import UploadImage from '@/components/UploadImage'
import UploadCardImage from '@/components/UploadCardImage'
import profileDefault from '@/assets/user_default.png'

export default {
    name: 'VisitorProfile',

    props: {
        mode: {
            Type: String,
            default: ''
        },
        visitor: {
            Type: Object,
            default: {}
        }
    },

    components: {
        UploadImage,
        UploadCardImage
    },

    directives: {
        mask
    },

    data () {
        return {
            form: this.getFormDateDefault(),
            employeeItems: [],
            bureauItems: [],
            valid: true,
            isNewImage: false,
            nationalTelCode: '+66',
            inputRules: [
                v => this.$validator.hasValue(v, this.$vuetify.lang.t('$vuetify.visitorForm.thisFieldIsRequired')),
                v => this.$validator.lengthNotExceed(v, 255, this.$vuetify.lang.t('$vuetify.visitorForm.thisFieldIsExceeded255Characters'))
            ],
            phoneRules: [
                v => this.$validator.lengthExactly(v, 11, this.$vuetify.lang.t('$vuetify.visitorForm.incorrectPhoneNumber'))
            ],
            errors: {}
        }
    },

    computed: {
        imageSizeError () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.visitorForm.ImageSizeCanNot200Kb'),
                type: 'notify-error'
            }
        },
        imageSizeCardError () {
            return {
                title: this.errorMsg,
                text: this.$vuetify.lang.t('$vuetify.visitorForm.ImageSizeCanNot10Mb'),
                type: 'notify-error'
            }
        }
    },

    methods: {
        async initVisitor () {
            await this.getEmployeeOptions()
            await this.getBureauOptions()
        },

        setErrorsInput (errors) {
            this.errors = errors
        },

        getFormDateDefault () {
            if (this.mode === 'edit') {
                return this.visitor
            } else {
                return {
                    profileImage: null,
                    citizenId: null,
                    firstName: null,
                    lastName: null,
                    gender: null,
                    bureauId: null,
                    email: null,
                    phone: null,
                    operatorId: null,
                    cardImage: null
                }
            }
        },

        imgProfile (img) {
            return img || profileDefault
        },

        changeProfileImg (event) {
            const fileList = event.target.files
            const maxFileSize = 200000
            const minFileSize = 25000

            const reader = new FileReader()
            let imgBase64 = null
            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.imageSizeError)
            } else {
                if (fileList[0]) {
                    reader.onload = () => {
                        imgBase64 = reader.result
                        this.form.profileImage = imgBase64
                        this.isNewImage = true
                    }

                    reader.readAsDataURL(fileList[0])
                }
            }
        },

        uploadCard (event) {
            const fileList = event.target.files
            const maxFileSize = 10000000
            const minFileSize = 25000

            const reader = new FileReader()
            let imgBase64 = null
            if (fileList[0] && (fileList[0].size < minFileSize || fileList[0].size > maxFileSize)) {
                this.$notify(this.imageSizeCardError)
            } else {
                if (fileList[0]) {
                    reader.onload = () => {
                        imgBase64 = reader.result
                        this.form.cardImage = imgBase64
                        this.isNewImage = true
                    }

                    reader.readAsDataURL(fileList[0])
                }
            }
        },

        removeImage () {
            this.form.cardImage = null
            this.$refs.uploadCardImage.clearProfile()
        },

        async getEmployeeOptions () {
            const res = await this.axios.get('employee/options')
            if (res && res.data && res.data.status === 'ok') {
                this.employeeItems = res.data.data
            }
        },

        async getBureauOptions () {
            const res = await this.axios.get('visitor/bureau/options')
            if (res && res.data && res.data.status === 'ok') {
                this.bureauItems = res.data.data

                // remove all bureaus option
                this.bureauItems.shift()
            }
        },

        validateFrom () {
            if (!this.form.profileImage) {
                this.$notify(this.imageSizeError)
                this.$refs.form.validate()
                return false
            } else {
                return this.$refs.form.validate()
            }
        }
    },

    async mounted () {
        await this.initVisitor()
    },

    watch: {
        form: {
            handler: async function (after, before) {
                this.$emit('input', after)
            },
            deep: true
        },
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.$utils.recheckValidate(this.$refs.form.inputs)
                this.initVisitor()
            },
            deep: true
        }
    }

}
</script>

<style lang="scss" scoped>
.card-profile {
    padding: 36px 46px;
    border-radius: 15px;
}
.card-header {
    font-size: 24px;
    font-weight: normal;
    color: #000;
    margin-bottom: 1rem;
}

.upload-container {
    min-width: 160px;
    width: 30%;
}

.profile-container {
    width: 70%;
}

::v-deep .gender {
    margin-top: 15px;

    .v-input--radio-group__input {
        flex-flow: column;
        align-items: flex-start;

        legend {
            width: 100%;
            text-align: left;
        }
    }

    .gender-radio {
        display: flex;
    }

    @media only screen and (max-width: 1450px) {
        .v-radio {
            margin-right: 8px;
        }
    }
}

::v-deep *:not(.v-radio) > .v-label {
    font-size: 14px !important;
    transform: translateY(-18px) scale(1) !important;
}

.card-container {
    position: relative;

    img {
        display: block;
    }

    .i-remove {
        position: absolute;
        top: 1px;
        right: 10px;
        color: rgb(0, 0, 0);
        opacity: 0.7;
    }

    .card-image {
        border-radius: 3%;
        height: 90px;
        margin-bottom: 10px;
    }

    .pointer-cursor {
        cursor: pointer;
    }
}
</style>
